import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { WidthObserver } from '@atlaskit/width-detector';
export var WidthContext = /*#__PURE__*/React.createContext(0);
var SCROLLBAR_WIDTH = 30;
export var WidthProvider = function WidthProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var handleWidthChange = function handleWidthChange(newWidth) {
    // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
    if (!newWidth || Math.abs(width - newWidth) < SCROLLBAR_WIDTH) {
      return;
    }
    setWidth(newWidth);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WidthObserver, {
    setWidth: handleWidthChange
  }), /*#__PURE__*/React.createElement(WidthContext.Provider, {
    value: width
  }, children));
};
export var WidthConsumer = WidthContext.Consumer;